import {
    accountSourceDataTypeChecker,
    getAccountSourceListStore,
} from 'owa-account-source-list-store';
import { errorThatWillCauseAlertAndThrow } from 'owa-trace';

/**
 * REFLOW TECHNICAL DEBT
 *
 * In the Respond approach the sourceId should be passed into components. To support the Reflow approach the
 * client-web code continues to use the userIdentity to identify mailboxes. This helper method allows for
 * getting a sourceId from the source list based on that user identity.
 *
 * Long term, meaning when all code has moved to the Respond approach, this method will be removed.
 *
 * @param userIdentity identifies the mailbox, when not specified the selected mailbox is assumed
 * @param dontThrowWhenNotFound can be set to true if the methods should not throw when the identity is not found
 * @returns SourceId for source associated with the supplied user identity, or undefined if not source was found
 */
export default function getSourceIdForUserIdentity(
    userIdentity?: string | null,
    dontThrowWhenNotFound?: boolean
): string {
    const accountSourceListStore = getAccountSourceListStore();
    if (userIdentity) {
        const filtered = accountSourceListStore.sources.filter(
            info =>
                accountSourceDataTypeChecker.isM365Mailbox(info) &&
                info.m365mailbox.userIdentity === userIdentity
        );

        if (filtered.length === 0) {
            if (dontThrowWhenNotFound) {
                return '';
            }

            // In Reflow the UX is reloaded after an account is added or deleted, because the
            // getSourceIdForUserIdentity is only intended for Reflow so we throw an error
            // when the sourceId cannot be found.
            errorThatWillCauseAlertAndThrow('SourceIdNotFoundForUserIdentity');
        }

        return filtered[0].sourceId;
    }

    if (!accountSourceListStore.selectedSourceId) {
        errorThatWillCauseAlertAndThrow('NoSelectedAccountForDefaultUserIdentity');
    }

    return accountSourceListStore.selectedSourceId;
}
